export const STATUS_PENDING = 'PENDING';
export const STATUS_FULLFILLED = 'FULLFILLED';
export const STATUS_REJECTED = 'REJECTED';